import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';
import type { TypographyVariant } from '@mui/material/Typography';

const useStyles = makeStyles()(() => ({
  simpleContent: {
    marginTop: 'auto',
    marginBottom: 'auto',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  simpleContentInner: {
    width: 500,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    '&.row': {
      flexDirection: 'row',
    },
  },
  simplePrimaryText: {
    paddingBottom: 16,
  },
  simpleSecondaryText: {
    textAlign: 'center',
    '&.row': {
      textAlign: 'left',
    },
  },
}));

function SimpleContentView({
  image,
  mainText,
  mainVariant = 'displayRegular',
  secondaryText,
  row,
}: {
  image: React.ReactElement;
  mainText?: string | undefined;
  mainVariant?: TypographyVariant | undefined;
  secondaryText: React.ReactNode;
  row?: boolean;
}) {
  const { classes, cx } = useStyles();
  return (
    <div className={classes.simpleContent}>
      <div className={cx(classes.simpleContentInner, row ? 'row' : '')}>
        {image}
        {mainText ? (
          <Typography variant={mainVariant} className={classes.simplePrimaryText}>
            {mainText}
          </Typography>
        ) : null}
        <Typography
          variant={'bodyRegular'}
          color={'textSecondary'}
          className={cx(classes.simpleSecondaryText, row ? 'row' : '')}
        >
          {secondaryText}
        </Typography>
      </div>
    </div>
  );
}

export default SimpleContentView;
